// GENERATED from the admin database (scripts/update_managed_defaults.py).
// Regenerate after making changes in /admin, then rebuild the zip.
export const MANAGED_FLEET = [
  {
    id: "6abc96739c57fbbf047feec1",
    title: "Crew Transfer Launch",
    description: "Prompt offshore transport from Tanjung Pengelih Ferry Terminal for shipping agents, surveyors, vessel owners and technical crews.",
    specs: [{ k: "Type", v: "Launch / Pilot Boat" }, { k: "Area", v: "Pasir Gudang · Pengerang" }, { k: "Status", v: "Active" }, { k: "Unit", v: "2" }],
    images: ["images/managed/fleet-01-0.jpg", "images/managed/fleet-01-1.jpg", "images/managed/fleet-01-2.jpg"],
  },
  {
    id: "6ac536e2c7f95f25219b3e37",
    title: "Cargo Boat / Landing Craft",
    description: "Port support service, delivering ship spare & store, provision, lubricant, underwater job, and many other task.",
    specs: [{ k: "Type", v: "Landing Craft" }, { k: "Loa", v: "10m" }, { k: "Status", v: "Active" }, { k: "Unit", v: "1" }],
    images: ["images/managed/fleet-02-0.jpg", "images/managed/fleet-02-1.jpg", "images/managed/fleet-02-2.jpg"],
  },
  {
    id: "6acb26146d49ca50ffdaf8bc",
    title: "SMALL ASSIST CRAFT",
    description: "To assist with under jetty work and place where the big boat cant reach.",
    specs: [{ k: "Type", v: "Small Craft" }, { k: "Loa", v: "6m" }, { k: "Status", v: "Active" }, { k: "Unit", v: "1" }],
    images: ["images/managed/fleet-03-0.jpg"],
  }
];

export const MANAGED_PROJECTS = [
  {
    id: "6abc96739c57fbbf047feec3",
    title: "KD Pendekar — Navy Warship Refloated",
    description: "In a defining salvage operation, we refloated the Royal Malaysian Navy's KD Pendekar — a 45-year-old warship raised from the seabed two nautical miles off Tanjung Penyusop, Johor, in October 2024.",
    images: ["images/managed/projects-01-0.jpg", "images/managed/projects-01-1.jpg"],
    news_url: "https://www.astroawani.com/berita-malaysia/kd-pendekar-berjaya-diapung-semula-tldm-491616",
    news_source: "Astro Awani",
  },
  {
    id: "6acb20976d49ca50ffdaf8bb",
    title: "Pengerang Terminal 2 High & Heavy Lifting",
    description: "We provided heavy lifting services at Petronas Pengerang Terminal 2 by using a crane barge to safely lift a JIB crane off its pedestal, place it onto our barge deck for bearing maintenance, and lift it back into place once the work was complete.",
    images: ["images/managed/projects-02-0.jpg", "images/managed/projects-02-1.jpg", "images/managed/projects-02-2.jpg", "images/managed/projects-02-3.jpg"],
  }
];
